import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import { KeyAction } from '@mescius/wijmo.grid'
import { InputDate } from '@mescius/wijmo.input'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import GetApp from '@material-ui/icons/GetApp'
import ErrorBoundary from '../ErrorBoundary'
import BootstrapAlert from '../element/BootstrapAlert'
import customContextMenu from '../../wijmo/customContextMenu'
import editableFlexGridInitialize from '../../wijmo/editableFlexGridInitialize'
import colElements from '../../wijmo/columnElements'
// import cellTemplateWithTitle from '../../wijmo/cellTemplateWithTitle'

import moment from 'moment'

import renderContractTypeBadge from '../element/ContractTypeBadge'
import renderPeriodBadge from '../element/PeriodBadge'

function getLayoutDefs (mode, isXr) {
  const isReadOnly = (mode !== 'createTrade' && mode !== 'editTrade')
  const hideInputs = (mode === 'view')
  const ldTwoLines = [
    {
      colspan: 3,
      cells: [
        { width: 0, maxWidth: 0, rowspan: 2 },
        { ...colElements.id, rowspan: 2 },
        { ...colElements.name, rowspan: 2, width: 250 }
      ]
    },
    {
      colspan: 3,
      cells: [
        colElements.price,
        colElements.rate_decimal,
        colElements.amount,
        { ...colElements.royality, colspan: 2 },
        colElements.royality_total
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colElements.comment, rowspan: 2 }
      ]
    },
    hideInputs
      ? {
          colspan: 1,
          cells: [
            {
              binding: 'wf_state',
              header: 'ステータス',
              cssClassAll: 'wj-style-green',
              isReadOnly: true,
              width: 120,
              align: 'center'
            },
            {
              binding: 'release_at',
              header: '発売日',
              cssClassAll: hideInputs ? 'wj-style-green' : 'wj-style-green-input',
              dataType: wjCore.DataType.String,
              isReadOnly: true,
              width: 120,
              align: 'center',
              format: 'yyyy-MM-dd',
              editor: new InputDate(document.createElement('div'), { format: 'yyyy-MM-dd' }),
              cellTemplate: (ctx) => ctx.item.stamp_data_item ? ctx.item.stamp_data_item.release_at : '-'
            }
          ]
        }
      : {
          colspan: 2,
          cells: [
            {
              binding: 'editable',
              header: '申請可',
              cssClassAll: 'wj-style-green',
              dataType: wjCore.DataType.String,
              isReadOnly: true,
              width: 120,
              align: 'center',
              cellTemplate: (ctx) => ctx.item.editable ? '〇' : '×'
            },
            {
              binding: 'to_apply',
              header: '申請対象',
              cssClassAll: hideInputs ? 'wj-style-green' : 'wj-style-green-input',
              dataType: wjCore.DataType.Boolean,
              isReadOnly: isReadOnly,
              width: 120,
              align: 'center'
            },
            {
              binding: 'editable',
              header: '不可理由',
              cssClassAll: 'wj-style-green',
              dataType: wjCore.DataType.String,
              isReadOnly: true,
              width: 120,
              align: 'center',
              cellTemplate: (ctx) => ctx.item.stamp_data_item ? '申請済み' : (ctx.item.contract_has_expired ? '契約期間終了' : '-')
            },
            {
              binding: 'release_at',
              header: '発売日',
              cssClassAll: hideInputs ? 'wj-style-green' : 'wj-style-green-input',
              dataType: wjCore.DataType.String,
              isReadOnly: isReadOnly,
              width: 120,
              align: 'center',
              format: 'yyyy-MM-dd',
              editor: new InputDate(document.createElement('div'), { format: 'yyyy-MM-dd' }),
              cellTemplate: (ctx) => ctx.item.to_apply ? ctx.text : '-'
            }
          ]
        },
    hideInputs
      ? {
          colspan: 2,
          cells: [
            {
              binding: 'download_url',
              header: 'ダウンロード',
              cssClassAll: 'wj-style-green',
              isReadOnly: isReadOnly,
              width: 125,
              align: 'center',
              cellTemplate: (ctx) => {
                const item = ctx.item
                if (item.wf_state === '承認済') {
                  if (item.stamp_data_item && item.stamp_data_item.downloaded_at) {
                    const mDownloadedAt = moment(item.stamp_data_item.downloaded_at)
                    return '<div class="d-flex flex-column">' +
                      `<small>${item.stamp_data_item.dl_user.name}様</small>` +
                      `<small>${mDownloadedAt.format('LL')}</small>` +
                      `<small>${mDownloadedAt.format('LTS')}</small>` +
                      '</div>'
                  } else if (item.stamp_data_item && item.stamp_data_item.expire_at) {
                    const expireAt = moment(item.stamp_data_item.expire_at).format('YYYY年MM月DD日')
                    return `<a href="${item.stamp_data_item.download_url ?? '#'}" class="dl-link">` +
                     '<span class="icon-get-app">DL</span><br/>' +
                     `<small>${expireAt}まで</small></a>`
                  } else {
                    return 'エラー'
                  }
                } else {
                  return '-'
                }
              },
              rowspan: 2
            },
            {
              binding: 'stamp_data_item.application_url',
              header: ' ',
              cssClassAll: 'wj-style-green',
              isReadOnly: isReadOnly,
              width: 80,
              align: 'center',
              cellTemplate: (ctx) => {
                if (ctx.text) {
                  return `<a href="${ctx.text}" class="btn bg-theme-success py-0">詳細</a>`
                }
              },
              rowspan: 2
            }
          ]
        }
      : null
  ].filter((col) => col)
  return {
    def: ldTwoLines,
    frozenColumns: 2,
    isUseAmount: (r, c) => r % 2 === 0 && c === 9,
    stampAmountAxis: (r) => ({ row: r + 1, col: 9 })
  }
}

//
export default function ItemsStampDataGrid (props) {
  const isXr = props.contracts.length > 0 && props.contracts[0].xr_contract_id !== null
  const [itemsCV, setItemsCV] = useState(null)
  const [downloadUrl, setDownloadUrl] = useState(0)
  const [layoutDef] = useState(getLayoutDefs(props.mode, isXr))
  const [jsonElem] = useState(props.itemsJsonId ? $('#' + props.itemsJsonId) : null)

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'coop_con_id', text: '契約ID', type: 'string', isEditable: false },
    { field: 'serial_no', text: 'No', type: 'string', isEditable: false },
    { field: 'name', text: '商品名', type: 'string', isEditable: false },
    { field: 'price', text: '税抜小売価格', type: 'number', isEditable: false },
    { field: 'rate_decimal', text: '料率', type: 'number', isEditable: false },
    { field: 'royality', text: '使用料単価', type: 'number', isEditable: false },
    { field: 'amount', text: '数量', type: 'number', isEditable: false },
    { field: 'royality_total', text: '使用料', type: 'number', isEditable: false },
    { field: 'comment', text: '備考', type: 'string', isEditable: false },
    { field: 'release_at', text: '発売日', type: 'string', isEditable: false }
  ]

  function sortByProperty (cv, property, direction) {
    const descriptions = cv.sortDescriptions
    descriptions.clear()
    descriptions.push(new wjCore.SortDescription(property, direction === 'asc'))
    descriptions.push(new wjCore.SortDescription('contract_id', true))
  }

  useEffect(() => {
    if (!itemsCV) {
      const oldItems = new Map(props.oldItemsJson
        .filter((item) => !('to_apply' in item && !item.to_apply)) // to_applyがセットされていなければ許可、されていればto_apply=falseを除外
        .map((item) => [item.id, item])
      )
      props.contracts.forEach((contract) => {
        if (contract.character.is_default) {
          contract.character.title = '★' + contract.character_name_free
        }
        contract.toString = () => {
          if (!contract.xr_contract_id) {
            let contractStr = `ID: ${contract.coop_con_id || '-'} / ${contract.character.title}`
            if (contract.contract_type !== 1) {
              if (contract.recouped_at) {
                contractStr += ` / リクープ済（${contract.recouped_at}）`
              } else {
                contractStr += ` / 残￥${(contract.royality - contract.spent_royality).toLocaleString()}`
              }
            }
            const contractTypeBadge = `<span class="contract-type-badge" data-contract-type="${contract.contract_type}" data-is-xr="false"></span>`
            const periodBadge = `<span class="period-badge" data-period-from="${contract.period_from}" data-period-to="${contract.period_to}"></span>`
            const deadlineStr = contract.application_deadline ? `<b class="text-danger">製造申請期限：${contract.application_deadline}</b>` : ''
            return `<span>${contractTypeBadge}${periodBadge}${deadlineStr}<br/><a href="${contract.contract_url || '#'}" target="_blank">${contractStr}</a></span>`
          } else {
            // クロスリクープの個別契約
            const note = contract.xr_note ? `（${contract.xr_note}）` : ''
            const contractStr = `ID: ${contract.coop_con_id || '-'} / ${contract.character.title}${note} / 目標額 ￥${contract.royality.toLocaleString()} / 使用済 ￥${contract.spent_royality.toLocaleString()}`
            const contractTypeBadge = `<span class="contract-type-badge" data-contract-type="${contract.contract_type}" data-is-xr="true"></span>`
            const periodBadge = `<span class="period-badge" data-period-from="${contract.period_from}" data-period-to="${contract.period_to}"></span>`
            const deadlineStr = contract.application_deadline ? `<b class="text-danger">製造申請期限：${contract.application_deadline}</b>` : ''
            return `<span>${contractTypeBadge}${periodBadge}${deadlineStr}<br/><a href="${contract.contract_url || '#'}" target="_blank">${contractStr}</a></span>`
          }
        }
      })
      const contractById = new Map(props.contracts.map((contract) => [contract.id, contract]))
      const items = (props.mode === 'createTrade' || props.mode === 'editTrade')
        ? props.items.filter((item) => !(
          item.stamp_data_item &&
          item.stamp_data_item.application.workflow &&
          item.stamp_data_item.application.workflow.is_approved
        ))
        : props.items
      const inputFields = 'id,to_apply,release_at'.split(',')
      items.map((item, i) => {
        item.contract = contractById.get(item.contract_id)
        item.coop_con_id = item.contract.coop_con_id

        item.rate = 'rate' in item ? Number(item.rate) : null
        item.royality = 'royality' in item ? Number(item.royality) : null
        if (props.mode === 'view') {
          item.wf_state = '未申請'
          if (item.stamp_data_item) {
            item.wf_state = '確認中'
            if (item.stamp_data_item.application.workflow) {
              const workflow = item.stamp_data_item.application.workflow
              if (workflow.is_approved) {
                item.wf_state = '承認済'
              } else if (workflow.is_returned) {
                item.wf_state = '差戻し'
              }
            }
          }
        }

        if (item.contract.contract_type === 2) {
          item.amount = '-'
        }

        // デフォルト値（元の入力データなど）を格納
        const defaultValues = oldItems.has(item.id)
          ? oldItems.get(item.id)
          : {
              to_apply: 0,
              release_at: moment().format('YYYY-MM-DD')
            }
        item.to_apply = oldItems.has(item.id)
        item.release_at = defaultValues.release_at

        // ソート用のプロパティ設定
        item.character_name = item.contract.character_name_free || (item.contract.character ? item.contract.character.title : '')
        item.sd_applied_at = item.stamp_data_item ? item.stamp_data_item.application.applied_at : null
        // アイテムの編集可否を設定
        item.contract_has_expired = moment(item.contract.period_to).add(1, 'd').isBefore(moment())
        item.editable = !(item.id === 0 || item.stamp_data_item || item.contract_has_expired)
        return 0
      })
      const _itemsCV = new wjCore.CollectionView(items, {
        calculatedFields: {
          rate_decimal: (obj) => 'rate' in obj ? obj.rate / 100 : null,
          royality_total: (obj) => obj.contract.contract_type === 2 ? '-' : obj.royality_prod
        },
        groupDescriptions: ['contract']
      })
      _itemsCV.collectionChanged.addHandler((cv, e) => {
        // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
        jsonElem && jsonElem.val(JSON.stringify(_itemsCV.items.filter((item) => item.id !== 0), inputFields))
      })
      jsonElem && jsonElem.val(JSON.stringify(_itemsCV.items.filter((item) => item.id !== 0), inputFields))

      setItemsCV(_itemsCV)

      if (props.mode === 'view') {
        // 証紙データダウンロード画面では証紙データ申請の新しい順にソートする
        sortByProperty(
          _itemsCV,
          'sd_applied_at',
          'desc'
        )
      } else {
        const url = new URL(location)
        sortByProperty(
          _itemsCV,
          url.searchParams.get('order_by') ?? 'applied_at',
          url.searchParams.get('order_direction') ?? 'desc'
        )
      }
    }
  }, [itemsCV])

  useEffect(() => {
    if (downloadUrl !== 0) {
      $('#dlModal').modal()
    }
  }, [downloadUrl])

  const gridInit = (grid) => {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        if (e.cell.classList.contains('wj-group')) {
          renderContractTypeBadge(e.cell)
          renderPeriodBadge(e.cell)
        }
        // 編集不可の行のスタイル変更
        if (e.cell.classList.contains('wj-style-green-input')) {
          const item = e.getRow().dataItem
          const column = grid.getBindingColumn(e.panel, e.row, e.col)
          const editable = item.editable && !(!item.to_apply && column.binding === 'release_at')
          if (!editable) {
            wjCore.removeClass(e.cell, 'wj-style-green-input')
            wjCore.addClass(e.cell, 'wj-style-green')
          }
        }

        // ステータス列の背景色設定
        const col = grid.getBindingColumn(e.panel, e.row, e.col)
        if (col.binding === 'wf_state') {
          switch (e.cell.innerHTML) {
            case '承認済':
              e.cell.classList.add('bg-default')
              break
            case '確認中':
              e.cell.classList.add('bg-default')
              break
            case '差戻し':
              e.cell.classList.add('bg-danger', 'text-white')
              break
            default:
              break
          }
        }

        // ダウンロードリンクのアイコンやポップアップ表示を設定
        $(e.cell).find('a.dl-link').each((i, elLink) => {
          $(elLink).find('.icon-get-app').each((i, el) => {
            ReactDOM.render(<GetApp />, el)
          })
          $(elLink).on('click', (e) => {
            e.preventDefault()
            setDownloadUrl(elLink.href)
          })
        })
      }
    })
    grid.beginningEdit.addHandler((s, e) => {
      // 未承認製造が存在するアイテムは編集不可
      const item = e.getRow().dataItem
      if (!item.editable) {
        e.cancel = true
      }

      const column = grid.getBindingColumn(e.panel, e.row, e.col)
      // 申請するアイテムのみ発売日を設定可能
      if (!item.to_apply && column.binding === 'release_at') {
        e.cancel = true
      }
    })

    grid.tableFormat = tableFormat

    customContextMenu(grid)
    editableFlexGridInitialize(grid)
  }

  return (
    <>
      <div className="text-center w-100">
        <div className="d-inline-block mw-100">
          <wjMultiRow.MultiRow showMarquee={true} stickyHeaders={true} itemsSource={itemsCV} layoutDefinition={layoutDef.def}
            keyActionTab={KeyAction.CycleEditable}
            frozenColumns={layoutDef.frozenColumns} multiRowGroupHeaders={true} initialized={gridInit}
            groupHeaderFormat="<b>{value}</b>"
            style={{ maxHeight: '500px' }}
          >
          </wjMultiRow.MultiRow>
        </div>
      </div>
      {/* ポップアップ設定 */}
      <div className="modal fade" id="dlModal" tabIndex="-1" role="dialog" aria-labelledby="dlModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="dlModalLabel">ダウンロード確認</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>証紙をダウンロードします。</p>
              <BootstrapAlert class="danger">
                <>
                  <h5>注意事項</h5>
                  <ul>
                    <li>あるアイテムに利用したデータ証紙を、他のアイテムに対して用いることはできません。</li>
                    <li>契約期間終了後、ダウンロードしたデータ証紙は必ず破棄してください。</li>
                  </ul>
                </>
              </BootstrapAlert>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn ol-theme-primary" data-dismiss="modal">キャンセル</button>
              <a href={downloadUrl} className="btn bg-theme-primary">ダウンロード</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

ItemsStampDataGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  contracts: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.oneOf('view createTrade editTrade confirm'.split(' ')),
  itemsJsonId: PropTypes.string,
  oldItemsJson: PropTypes.arrayOf(PropTypes.object),
  displayRoyalityTotal: PropTypes.bool
}

ItemsStampDataGrid.defaultProps = {
  itemsJsonId: '',
  oldItemsJson: [],
  displayRoyalityTotal: true
}

$('#items-stamp-data-grid').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ItemsStampDataGrid {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
